import { module } from 'angular';
import templateBuilderColumnsDisplay from './builder/display.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/columns/display.html', templateBuilderColumnsDisplay);
});
